/**
 * Calculate the discounted price given an original price and a discount percentage.
 * Ensures the discount percentage is between 0 and 100.
 *
 * @param originalPrice - The starting price
 * @param discountPercentage - The percentage to deduct (0 to 100)
 * @returns The rounded discounted price
 */
export const calculateDiscountedPrice = (
  originalPrice: number,
  discountPercentage: number | undefined
): number => {
  if (
    discountPercentage === undefined ||
    discountPercentage <= 0 ||
    originalPrice <= 0
  ) {
    return originalPrice;
  }

  // Cap discount at 100%
  const effectiveDiscount = Math.min(discountPercentage, 100);

  return Math.round(originalPrice * (1 - effectiveDiscount / 100));
};
